export class Constants {
  public static CONVENIO_MULTILARETAL: string = "4";
  public static INSCRIPTO: string = "3";
  public static EXENTO: string = "2";
  public static NO_INCRIPTO: string = "1";
  public static REGIMEN_SIMPLIFICADO = "5";
}

export class MultilateralAgreement {
  public static SYSTEM_PADRON_WEB: string = "Constancia de sistema padron web";
  public static CM05: string = "CM05";
}

export class DocumentId {
  public static CPF_FRENTE: number = 100;
  public static CPF_DORSO: number = 101;
  public static CONTRATO_SOCIAL: number = 102;
  public static COMPROBANTE_DIRECCION: number = 103;
  public static FOTO_COMERCIO: number = 12;
}

export class DocName {
  public static CPF_FRENTE: string = "RG E CPF FRENTE";
  public static CPF_DORSO: string = "RG E CPF VERSO";
  public static CONTRATO_SOCIAL = "Contrato Social/Requerimento de empresário Individual/ Certificado de MEI";
  public static COMPROBANTE_DIRECCION: string = "Comprovante de Endereço";
}

export class CreateFile {
  public static ONE_FILE: boolean = true;
}

export enum IibbCategory {
  NoInscripto = 1,
  Exento = 2,
  InscriptoLocal = 3,
  ConvenioMultilateral = 4,
  RegimenSimplificado = 5,
}

export class DocKey {
  public static CPF_FRENTE: string = "CpfFrenteSolicitante";
  public static CPF_DORSO: string = "CpfDorsoSolicitante";
  public static CONTRATO_SOCIAL: string = "ContratoSocial";
  public static COMPROBANTE_DIRECCION: string = "ComprobanteDireccion";
  public static FOTO_COMERCIO: number = 12;

}

export const NameFileRegex = /^[a-zA-Z0-9_\-() .]+$/;
